import React, { useEffect, useState } from "react";
import { humanlossdashboardincidentcarddata } from "../../../../../Services/EndPoints";
import { getData } from "../../../../../Services/Services";
import "../HumanLossDashboard.css";

const PALETTE = [
  { bg: "#FFF0F0", color: "#D95555" },
  { bg: "#FFF4EA", color: "#D4772A" },
  { bg: "#EEFAF3", color: "#27A05A" },
  { bg: "#EBF4FF", color: "#3579D4" },
  { bg: "#F3EEFF", color: "#8B52D6" },
  { bg: "#E7FAFB", color: "#1EA6B4" },
  { bg: "#FFFAEB", color: "#C49A17" },
  { bg: "#FEF0F9", color: "#C93E9F" },
  { bg: "#EBF4FF", color: "#2A6591" },
  { bg: "#FFF0F0", color: "#D95555" },
  { bg: "#FFF4EA", color: "#D4772A" },
  { bg: "#EEFAF3", color: "#27A05A" },
];

// SVG icons matching cold wave style
function IncidentIcon({ label = "", color = "#2A6591" }) {
  const k = label.toLowerCase();
  const sw = "1.5";
  const r = "round";

  if (k.includes("drown"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><circle cx="10" cy="5" r="2.5" stroke={color} strokeWidth={sw}/><path d="M3 16c1.5-2 3-3 4-3s2.5 1 3 3c.5-2 1.5-3 3-3s2.5 1 4 3" stroke={color} strokeWidth={sw} strokeLinecap={r}/><path d="M10 8v5" stroke={color} strokeWidth={sw} strokeLinecap={r}/></svg>);
  if (k.includes("lightning") || k.includes("bolt"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><path d="M11 2L5 11h4l-2 7 8-9h-4l2-7z" stroke={color} strokeWidth={sw} strokeLinejoin={r}/></svg>);
  if (k.includes("snake"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><path d="M4 16c0-3 2-5 4-5s3 2 4 2 3-2 4-5" stroke={color} strokeWidth={sw} strokeLinecap={r}/><circle cx="15" cy="6" r="2" stroke={color} strokeWidth="1.3"/></svg>);
  if (k.includes("vehicle") || k.includes("accident") || k.includes("road"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><rect x="3" y="8" width="14" height="6" rx="2" stroke={color} strokeWidth={sw}/><circle cx="7" cy="15" r="1.5" stroke={color} strokeWidth="1.3"/><circle cx="13" cy="15" r="1.5" stroke={color} strokeWidth="1.3"/><path d="M5 8L7 4h6l2 4" stroke={color} strokeWidth={sw} strokeLinejoin={r}/></svg>);
  if (k.includes("boat"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><path d="M3 13l2-6h10l2 6" stroke={color} strokeWidth={sw} strokeLinejoin={r}/><path d="M10 7V4" stroke={color} strokeWidth={sw} strokeLinecap={r}/><path d="M10 4l4 3" stroke={color} strokeWidth="1.3" strokeLinecap={r}/><path d="M2 16c2-1.5 4-1.5 6 0s4 1.5 6 0s4-1.5 6 0" stroke={color} strokeWidth="1.3" strokeLinecap={r}/></svg>);
  if (k.includes("storm") || k.includes("thunder"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><path d="M5 11a4 4 0 017-3 3 3 0 013 5H5z" stroke={color} strokeWidth={sw} strokeLinejoin={r}/><path d="M9 13l-1 4h2l-1 3" stroke={color} strokeWidth="1.3" strokeLinecap={r}/></svg>);
  if (k.includes("train") || k.includes("rail"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><rect x="5" y="3" width="10" height="12" rx="3" stroke={color} strokeWidth={sw}/><path d="M5 10h10" stroke={color} strokeWidth="1.2"/><circle cx="8" cy="13" r="1" fill={color}/><circle cx="12" cy="13" r="1" fill={color}/><path d="M7 15l-2 3M13 15l2 3" stroke={color} strokeWidth="1.3" strokeLinecap={r}/></svg>);
  if (k.includes("fire"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><path d="M10 17c-4 0-5-3-4-7 .5 2 2 3 2 3s-2-4 1-7c-.5 3 2.5 4 2.5 4s2-2 .5-5c3 3 3 8 1 10 .5-2-1-3-1-3C13 14 10 17 10 17z" stroke={color} strokeWidth={sw} strokeLinejoin={r}/></svg>);
  if (k.includes("air") || k.includes("plane"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><path d="M10 3v14M6 8l4-2 4 2M4 14l6-3 6 3" stroke={color} strokeWidth={sw} strokeLinecap={r} strokeLinejoin={r}/></svg>);
  if (k.includes("building") || k.includes("collapse") || k.includes("wall"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><rect x="4" y="5" width="12" height="12" rx="1" stroke={color} strokeWidth={sw}/><path d="M8 17v-4h4v4M4 9h12" stroke={color} strokeWidth="1.2"/><rect x="7" y="6" width="2" height="2" rx=".5" stroke={color} strokeWidth="1"/><rect x="11" y="6" width="2" height="2" rx=".5" stroke={color} strokeWidth="1"/></svg>);
  if (k.includes("all") || k.includes("total"))
    return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><rect x="3" y="3" width="14" height="14" rx="3" stroke={color} strokeWidth={sw}/><path d="M7 10h6M10 7v6" stroke={color} strokeWidth="1.6" strokeLinecap={r}/></svg>);
  // Default skull
  return (<svg viewBox="0 0 20 20" fill="none" width="20" height="20"><circle cx="10" cy="8" r="5" stroke={color} strokeWidth={sw}/><circle cx="8" cy="7.5" r="1" fill={color}/><circle cx="12" cy="7.5" r="1" fill={color}/><path d="M8 13v4M10 13v4M12 13v4" stroke={color} strokeWidth="1.3" strokeLinecap={r}/></svg>);
}

export default function HumanDashboardCard({
  config, clickedKey, setClickedKey,
  onIncidentSelect, fromDateNew, toDateNew,
  applyClicked, onApplyHandled, firstLoad, setLoader,
}) {
  const [cardData, setCardData] = useState({});
  const [totalDeaths, setTotalDeaths] = useState(0);
  const [incidentData, setIncidentData] = useState([]);

  const refreshDashboard = async (from, to) => {
    setLoader(true);
    try {
      const response = await getData(
        humanlossdashboardincidentcarddata.replace("FROMDATE", from).replace("TODATE", to)
      );
      setIncidentData(response || []);
      const mappedData = config?.data.reduce((acc, conf) => {
        const incident = (response || []).find(i => i.incident_name === conf.label);
        if (incident) acc[conf.key] = incident.count || 0;
        return acc;
      }, {});
      const total = Object.values(mappedData).reduce((s, c) => s + c, 0);
      setTotalDeaths(total);
      setCardData(mappedData);
    } catch (e) { console.error(e); }
    finally { setLoader(false); }
  };

  useEffect(() => { if (firstLoad) refreshDashboard(fromDateNew, toDateNew); }, [firstLoad]);
  useEffect(() => { if (applyClicked) { refreshDashboard(fromDateNew, toDateNew); onApplyHandled(); } }, [applyClicked]);

  const handleCardClick = (conf) => {
    if (conf.label === "All Incidents Data") {
      onIncidentSelect("ALL", conf.label);
      return;
    }
    const clicked = incidentData.find(i => i.incident_name === conf.label);
    if (clicked) onIncidentSelect(clicked.incident_id, clicked.incident_name);
    else onIncidentSelect(0, conf.label);
  };

  return (
    <div className="hld-cards-section">
      {/* ── Header row ── */}
      <div className="hld-cards-header">
        <span className="hld-cards-header-left">{config.title}</span>
        <div className="hld-cards-header-right">
          <div className="hld-cards-stat">
            <span className="hld-cards-stat-dot" style={{ background: "#1C4E72" }} />
            <span className="hld-cards-stat-val" style={{ color: "#1C4E72" }}>{totalDeaths.toLocaleString("en-IN")}</span>
            <span>Deaths</span>
          </div>
        </div>
      </div>

      {/* <div className="hld-cards-hint">Click any card to view detailed analytics ↓</div> */}

      {/* ── Card grid ── */}
      <div className="hld-cards-grid">
        {config?.data.slice(0, 25).map((conf, idx) => {
          const p = PALETTE[idx % PALETTE.length];
          const active = clickedKey === conf.key;
          const val = cardData[conf.key];
          const hasData = val != null && val > 0;
          const isAll = conf.label === "All Incidents Data";

          return (
            <div
              key={conf.key || idx}
              className={`hld-card${active ? " hld-card--active" : ""}`}
              style={{ "--card-accent": p.color }}
              onClick={() => { setClickedKey(conf.key); handleCardClick(conf); }}
            >
              {/* Icon */}
              <span className="hld-card-icon" style={{ background: p.bg }}>
                <IncidentIcon label={conf.label} color={p.color} />
              </span>

              {/* Info */}
              <div className="hld-card-info">
                <span className="hld-card-label">{conf.label}</span>
                <span className="hld-card-value">
                  {isAll ? totalDeaths.toLocaleString("en-IN") : (hasData ? val.toLocaleString("en-IN") : "0")}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}